import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import HomeRouter from "./HomeRouter";
import DashboardRouter from "./DashboardRouter";
import { AllRoutes } from "./AllRoutes";

// Payment & verification pages
import NotVerified from "./views/DashboardView/Components/NotVerified";
import EsewaFailure from "./views/pages/EsewaPages/EsewaFailure";
import EsewaSuccess from "./views/pages/EsewaPages/EsewaSuccess";
import KhaltiRedirect from "./views/pages/KhaltiPages/KhaltiRedirect";

const AppRouter = () => {
  const { pathname } = useLocation();

  // Scroll to top on route change
  // Block body: the effect must not return scrollTo's result, or React will
  // try to call it as a cleanup function on the next route change.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Auth state
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isEmailVerified = useSelector((state) => state.auth.isEmailVerified);

  
  return (
    <Routes>
      {/* Home pages with layout */}
      <Route path="/" element={<HomeRouter />}>
        {AllRoutes.homeRoute.map((item, id) => (
          <Route key={id}>
            {/* Main page */}
            <Route path={item.link} element={item.component} />
            {/* Submenu if exists */}
            {item.submenu &&
              item.submenu.map((subitem, subid) => (
                <Route key={subid} path={subitem.link} element={subitem.component} />
              ))}
          </Route>
        ))}
      </Route>

      {/* Dashboard / protected routes */}
      <Route element={<DashboardRouter />}>
        {/* Payment pages */}
        <Route path="page/esewa_payment_success" element={<EsewaSuccess />} />
        <Route path="page/esewa_payment_failed" element={<EsewaFailure />} />
        <Route path="page/khalti_payment" element={<KhaltiRedirect />} />

        {/* Dashboard protected routes */}
        {AllRoutes.dashboardRoute.map((item, id) => (
          <Route
            key={id}
            path={item.link}
            element={
              <ProtectedRoute user={isLoggedIn}>
                {isEmailVerified ? item.component : <NotVerified />}
              </ProtectedRoute>
            }
          />
        ))}
      </Route>

      {/* Catch-all 404 (optional) */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

// Protected route wrapper
const ProtectedRoute = ({ user, children }) => {
  if (!user) return <Navigate to="/" replace />;
  return children;
};

export default AppRouter;
